/*!
 * Copyright 2019 yangjunbao <yangjunbao@shimo.im>. All rights reserved.
 * @since 2019-07-09 12:02:42
 */
import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { handleError } from '../../lib/lib-util';
import { callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { eKuaibaoSDK } from '@ekuaibao/sdk-bridge/sdk/ekuaibao';
import registerAPI from '../registerAPI';
import initializeTitle from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { fetchHandleError } from '../FetchConfig';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import initLogger from '../../logger/initLogger';
import { initDatafluxRum } from '../dataflux-rum';
initDatafluxRum();
initLogger();
window.__PLANTFORM__ = 'APP';
window.IS_LDAP = true;
function startup() {
    app.use({
        id: '@app',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
fetchHandleError(handleError);
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initColors();
                    initRoute();
                    initPlatformInfo();
                    app.container.set('IDeviceType', 'DESKTOP');
                    app.container.set('ISMessageEntry', false);
                    app.sdk = app.container.get(eKuaibaoSDK);
                    registerHandler();
                    startup();
                    registerAPI();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4, app.sdk.initialize()];
                case 2:
                    _a.sent();
                    setNetworkAdapter();
                    return [3, 5];
                case 3:
                    e_1 = _a.sent();
                    return [4, newHomeConfig()];
                case 4:
                    _a.sent();
                    setNetworkAdapter();
                    return [2];
                case 5: return [4, newHomeConfig()];
                case 6:
                    _a.sent();
                    initializeTitle();
                    return [2];
            }
        });
    });
}
